// === useBookmark.ts (custom hook) ===
import { useState, useEffect } from "react";
import {
  updateBookmark as apiUpdateBookmark,
  deleteBookmark as apiDeleteBookmark,
  createBookmark as apiCreateBookmark,
} from "../api/bookmarks";

import { useAuth } from "../context/AuthContext";
import { useMessages } from "../context/MessagesContext";

export interface IBookmark {
  id: number;
  idUser: number;
  idContact?: number;
  idMessage?: number;
  title?: string;
  desc?: string;
  icon: string;
  createdAt: string;
}

export const useBookmark = () => {
  const { loading, favourites } = useMessages();

  // -----------------------------------------------------
  // 🔹 CRUD
  // -----------------------------------------------------
  const updateBookmark = async (updated: IBookmark) => {
    await apiUpdateBookmark(updated);
  };

  const deleteBookmark = async (idUser: number, idContact: number) => {
    await apiDeleteBookmark(idUser, idContact);
  };

  const createBookmark = async (data: Partial<IBookmark>) => {
    await apiCreateBookmark(data);
  };

  return {
    loading,
    favourites,
    updateBookmark,
    deleteBookmark,
    createBookmark,
  };
};
